import { Flex } from "rebass";
import styled from "styled-components";

export const BaseSection = styled(Flex)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  gap: 36px;
`;

export const EarlyAccessSection = styled(Flex)`
  flex-direction: column;
  gap: 12px;
  padding: 12px 24px 30px;
  border-top: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
`;

export const Container = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.darkerNed};
  border-radius: 12px;
  max-width: 500px;
  min-width: 350px;
  position: relative;
  width: 90vw;
`;
